import { G } from '@mobily/ts-belt';
import { createPrefetchSession } from 'common/offline/prefetchSession';
import { useQueryClient } from 'react-query';
import { clearPersistedQueryClientCache } from 'common/offline/reactQueryPersistence';
import { prefetchPropertyData } from './useManualCacheData';

export const usePrefetchWorkSessionData = (propertyId: number | null) => {
  const qc = useQueryClient();

  const prefetch = async (callback?: () => Promise<void>) => {
    if (G.isNullable(propertyId)) return;

    await clearPersistedQueryClientCache();
    const session = createPrefetchSession(qc);

    await prefetchPropertyData(session, propertyId);

    await callback?.();
    await session.persist();
  };

  return { prefetch };
};
